// datatru/static/js/components/bottom-tab-bar.js
// Mobile bottom tab bar with "More" slide-up sheet.

import { withThemeAware } from '../theme-toggle.js';

export function bottomTabBar() {
  return withThemeAware({
    moreOpen: false,

    openMore() {
      this.moreOpen = true;
    },

    closeMore() {
      this.moreOpen = false;
    },
  });
}
